import { render, staticRenderFns } from "./EditColumns.vue?vue&type=template&id=6391f802&"
import script from "./EditColumns.vue?vue&type=script&lang=ts&"
export * from "./EditColumns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports